import React, {useState, useEffect}from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Image,
  TouchableOpacity,
  Dimensions,
  Text,
  FlatList,
  ActivityIndicator,
  ImageBackground,
  Modal,
  Linking,
  Platform
} from 'react-native';
import styled from 'styled-components/native';
import {
  WorkoutsParent,
  WorkoutContainerText,
  WorkoutTextHeader,
  CerebrocoreCommonTextComponent,
  WorkoutContainerHeaderThree,
  WorkoutCommonButton
} from '../../styles/common-styles';
import {FontAwesome5} from "@expo/vector-icons";
import {mainSite} from "../../config";
import Bugsnag from "@bugsnag/expo";

function TodaysWorkout({ screenWidth, navigation, userId }) {

  const dispatch = useDispatch();

  const { current_workout_activity, current_workout, workout_loading_msg, daily_workout_completed,  } = useSelector((state) => state.cbcWorkout);
  const { userType } = useSelector((state) => state.cbcAuthorization);
  const { activityChoices } = useSelector((state) => state.cbcActivities);

  const [devicePhone, setDevicePhone] = useState(1);
  const [workoutStarted, setWorkoutStarted] = useState(false);

  const [WorkoutImageJSX, setWorkoutImageJSX] = useState(WorkoutImagePhone);
  const [TodaysWorkoutJSX, setTodaysWorkoutJSX] = useState(TodaysWorkoutParentPhone)
  const [TodaysWorkoutContainerJSX, setTodaysWorkoutContainerJSX] = useState(TodaysWorkoutContainerPhone)
  const [TodoListJSX, setTodoListJSX] = useState(TodoListPhone)
  const [TodaysWorkoutHeaderJSX , setTodaysWorkoutHeaderJSX] = useState(TodaysWorkoutHeaderPhone);
  const [TodaysWorkoutTextJSX , setTodaysWorkoutTextJSX] = useState(TodaysWorkoutTextPhone);
  const [WorkoutCurrentActivityJSX , setWorkoutCurrentActivityJSX] = useState(WorkoutCurrentActivityPhone);
  const [TodaysWorkoutActivityHeaderJSX , setTodaysWorkoutActivityHeaderJSX] = useState(TodaysWorkoutActivityHeaderPhone)
  const [modalVisible, setModalVisible] = useState(false); // State to manage modal visibility

  let isWarmUpActivity = false;
  let hasActivityChoices = false;

  if (current_workout_activity) {
    if (current_workout && current_workout_activity.id == 27) {
      isWarmUpActivity = true;
    }

    if (current_workout_activity.activity_choices) {
      hasActivityChoices = true;
    }
  }

  const practitionerActivityList = [
    {
      activity_list: activityChoices,
      category_name: 'Free choice',
      category_text: 'Please select an activity from below.',
    },
  ];

  useEffect(() => {
    if (current_workout && current_workout.activities) {
      const started = current_workout.activities.some(activity => activity.completed);
      setWorkoutStarted(started);
      //dispatch(PivotLogging({moduleName: 'TodaysWorkout' , consoleLog: `current activity check:  ${JSON.stringify(current_workout)}`}));
    }
  }, [current_workout]);


  const openAppStore = () => {
    let url;

    // Define the app store URL based on the platform
    if (Platform.OS === 'ios') {
      url = 'itms-apps://itunes.apple.com/app/id6449496314';  // Replace YOUR_APP_ID_HERE
    } else if (Platform.OS === 'android') {
      url = 'market://details?id=com.ehouston.cerebrocoreclientworkoutdashboard'; // Replace YOUR_PACKAGE_NAME_HERE
    }

    // Open the URL
    Linking.canOpenURL(url).then(supported => {
      if (supported) {
        Linking.openURL(url);
      }
    });
  };

  // useEffect(() => {
  //   if(current_workout.workout_version != null && Platform.OS !== 'web'){
  //     try{
  //       const appJson = require('appJson');
  //       //console.log("App JSON", appJson);
  //       //console.log(appJson.expo.version);
  //
  //       //console.log(appJson.expo.version, current_workout.workout_version)
  //       if(appJson.expo.version >= current_workout.workout_version){
  //         setModalVisible(false);
  //       } else {
  //         setModalVisible(true);
  //       }
  //     } catch (e){
  //       //console.log("App JSON MISSING");
  //       setModalVisible(true);
  //     }
  //   }
  // }, [current_workout.workout_version]);

  const isLoadingWorkout = workout_loading_msg === 'pending';

  useEffect(() => {
    if(screenWidth < 768){
      setDevicePhone(1);
    } else {
      setDevicePhone(0);
    }
  }, [screenWidth]);

  useEffect(() => {
    if(devicePhone == 1){
      setWorkoutImageJSX(WorkoutImagePhone);
      setTodaysWorkoutJSX(TodaysWorkoutParentPhone)
      setTodaysWorkoutContainerJSX(TodaysWorkoutContainerPhone)
      setTodoListJSX(TodoListPhone)
      setTodaysWorkoutHeaderJSX(TodaysWorkoutHeaderPhone);
      setTodaysWorkoutTextJSX(TodaysWorkoutTextPhone)
      setWorkoutCurrentActivityJSX(WorkoutCurrentActivityPhone);
      setTodaysWorkoutActivityHeaderJSX(TodaysWorkoutActivityHeaderPhone)
    } else {
      setWorkoutImageJSX(WorkoutImageDesktopTablet);
      setTodaysWorkoutJSX(TodaysWorkoutParentTablet);
      setTodaysWorkoutContainerJSX(TodaysWorkoutContainerTablet)
      setTodoListJSX(TodoListTablet)
      setTodaysWorkoutHeaderJSX(TodaysWorkoutHeaderTablet);
      setTodaysWorkoutTextJSX(TodaysWorkoutTextTablet)
      setWorkoutCurrentActivityJSX(WorkoutCurrentActivityTablet);
      setTodaysWorkoutActivityHeaderJSX(TodaysWorkoutActivityHeaderTablet)
    }
  }, [devicePhone]);

  return (

      <TodaysWorkoutJSX screenWidth={screenWidth}>

        { devicePhone == 0 && (
            <WorkoutImageJSX
                screenWidth={screenWidth}
                source={{
                  uri: `${mainSite}/wp-content/uploads/2023/05/c3ed6eb0-a937-42eb-9b2c-00d89a74878f.png`,
                }}
                resizeMode='contain'
            />
        )}

        <TodaysWorkoutContainerJSX>
          {devicePhone == 1 && (
              <BackgroundImage
                  source={{ uri: 'https://dev.cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/backgrounds/Cerebrocore_workout-bkg-weight.png' }}
              />
          )}
          { devicePhone == 1 && (
              <WorkoutImageJSX
                  screenWidth={screenWidth}
                  source={{
                    uri: `${mainSite}/wp-content/uploads/2023/05/c3ed6eb0-a937-42eb-9b2c-00d89a74878f.png`,
                  }}
                  resizeMode='contain'
              />
          )}

          <TodaysWorkoutHeaderJSX style={{ marginBottom: 10, width: '100%' }}>
            Today's Workout
          </TodaysWorkoutHeaderJSX>
          {/* <TodaysWorkoutTextJSX screenWidth={screenWidth}>
          It's time to pump the iron! Remember, consistency is key. Keep up with your workouts to earn your streaks!
        </TodaysWorkoutTextJSX> */}

          {
            workoutStarted ? (
                <TodaysWorkoutTextJSX>
                  You're on the right track! Pickup where you left off and complete your workout.
                </TodaysWorkoutTextJSX>
            ) : daily_workout_completed ? (
                <TodaysWorkoutTextJSX>
                  Fantastic job! You have finished your workout today. Don't forget to complete training 3 times a week to earn your streak!
                </TodaysWorkoutTextJSX>
            ) : (
                <TodaysWorkoutTextJSX>
                  It's time to pump the iron! Let's get started with your workout.
                </TodaysWorkoutTextJSX>
            )
          }

          {isLoadingWorkout && (
              <ActivityIndicator style={{ marginTop: 40, marginBottom: 40 }} />
          )}
          {workoutStarted && (
              <TodoListJSX>
                {!isLoadingWorkout &&
                    current_workout.activities.map((item , x) => {
                      const isCompleted = item.completed;

                      return (
                          <ActivityContainer key={item.id.toString()}>
                            <ActivityStatus isCompleted={isCompleted}>
                              <Text>
                                { isCompleted ?
                                    <FontAwesome5 name="check" size={14} color="white" />
                                    : '' }
                              </Text>
                            </ActivityStatus>
                            <ActivityName devicePhone={devicePhone}>
                              {item.label == 'Warm Up' ?
                                  `${item.label}`
                                  : `${item.label} ${x}: ${item.name}`}
                            </ActivityName>
                          </ActivityContainer>
                      )
                    })}
              </TodoListJSX>
          )}

          <WorkoutCommonButton
              onPress={() => {
                setTimeout(function(){
                  if (hasActivityChoices) {
                    const activityObj = [
                      {
                        activity_list: current_workout_activity.activity_choices,
                        category_name: 'Free choice',
                        category_text: 'Please select an activity from below.',
                      },
                    ]
                    navigation.navigate('activitylist', {
                      activityObj,
                      current_workout,
                      navigation,
                      isWorkout:true
                    });
                  } else if (isWarmUpActivity) {
                    navigation.navigate('workoutintro', { navigation });
                  } else {

                    try{
                      Bugsnag.notify('User navigating to GameView');
                    } catch(e){
                      //dispatch(PivotLogging({moduleName: 'TodaysWorkout' , consoleLog: `Unable to notify bugsnag: ${e}`}));
                    }

                    Bugsnag.leaveBreadcrumb('Navigating to GameView');
                    //dispatch(PivotLogging({moduleName: 'TodaysWorkout' , consoleLog: 'navigating to Gameview'}));
                    navigation.navigate('gameview', {
                      current_workout_activity,
                      current_workout,
                    });
                  }
                }, 500);
              }}
              style={{marginTop: 15, width:200}}
              disabled={!current_workout_activity || isLoadingWorkout}
          >
            {
              workoutStarted ? (
                  <WorkoutStartButton style={{ color: 'white', fontWeight: '500' }}>
                    CONTINUE
                  </WorkoutStartButton>
              ) : daily_workout_completed ? (
                  <WorkoutStartButton style={{ color: 'white', fontWeight: '500', fontSize: 13 }}>
                    NEXT WORKOUT
                  </WorkoutStartButton>
              ) : (
                  <WorkoutStartButton style={{ color: 'white', fontWeight: '500' }}>
                    GET STARTED
                  </WorkoutStartButton>
              )
            }

          </WorkoutCommonButton>

          { daily_workout_completed && !workoutStarted && (
              <FreeChoiceButton
                  onPress={() => {
                    const activityObj = [
                      {
                        activity_list: activityChoices,
                        category_name: 'Free choice',
                        category_text: 'Please select an activity from below.',
                      },
                    ];
                    navigation.navigate('activitylist', {
                      activityObj,
                      current_workout,
                      navigation,
                      isWorkout:false
                    });
                  }}
                  style={{marginTop: 15, width:200}}
              >
                <WorkoutStartButton style={{ color: '#3366CC', fontWeight: '500' }}>
                  FREE CHOICE
                </WorkoutStartButton>
              </FreeChoiceButton>
          )}

        </TodaysWorkoutContainerJSX>
        <Modal
            animationType="slide"
            transparent={true}
            visible={modalVisible}
        >
          <ModalViewParent>
            <ModalView>
              <WorkoutTextHeader>Please Update</WorkoutTextHeader>
              <WorkoutContainerText style={{marginTop:10}}>
                You are using an outdated version of the app.{'\n'}{'\n'}Please update your app:
              </WorkoutContainerText>
              <ButtonCont onPress={() => {
                openAppStore();  // Open the respective app store
              }}>
                <ButtonText>GO TO APP STORE</ButtonText>
              </ButtonCont>
            </ModalView>
          </ModalViewParent>
        </Modal>
      </TodaysWorkoutJSX>
  );
}

export const TodaysWorkoutParentTablet = styled.View`
  padding:20px;
  max-width:450px;
  background: #f8f9fb;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const TodaysWorkoutParentPhone = styled.ImageBackground`
  width: 100%;
  height:auto;
  padding: 40px 40px 40px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border:1px solid black;
  background-color:#282F63;
`;

export const WorkoutStartButton = styled.Text`
  font-family: 'Montserrat-SB';
`;

export const BackgroundImage = styled.Image`
  position: absolute;
  width: 100%;
  height: 100%;
  resizeMode: cover;
  overflow:visible;
`;

export const WorkoutContainerLeftImage = styled.Image`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WorkoutImage = styled.Image`
  width: ${(props) => props.screenWidth * 0.275}px;
  height: ${(props) => props.screenWidth * 0.275}px;
  resizeMode: contain;
`;

export const WorkoutImagePhone = styled(WorkoutImage)`
  max-width: 150px;
  max-height: 150px;
  margin-bottom:30px;
`;

export const WorkoutImageDesktopTablet = styled(WorkoutImage)`
  max-width: 150px;
  max-height: 150px;
`;

export const TodaysWorkoutContainerTablet = styled.View`
  margin-left: 35px;
  width:100%;
`;

export const TodaysWorkoutContainerPhone = styled.View`
  width:100%;
`;

export const TodaysWorkoutHeaderTablet = styled(WorkoutTextHeader)`
  width: 100%;
`;

export const TodaysWorkoutHeaderPhone = styled(WorkoutTextHeader)`
  width: 100%;
  color:#c4579d;
`;

export const WorkoutContainerLeftTextHeader = styled.Text`
  font-size: 18px;
  font-weight: 700;
  color: #4573d0;
  margin-bottom: 10px;
  transform: scale(1, 1.15);
`;

export const WorkoutContainerLeftTextActivityHeader = styled.Text`
  font-size: 16px;
  font-weight: 800;
  color: #38406f;
`;

export const WorkoutCurrentActivityTablet = styled(WorkoutContainerText)`
  font-size: 16px;
  font-weight: 500;
  color: #38406f;
  margin-bottom: 15px;
`;

export const WorkoutCurrentActivityPhone = styled(WorkoutContainerText)`
  font-size: 16px;
  font-weight: 500;
  color: white;
  margin-bottom: 15px;
`;

export const StartActivityButton = styled.TouchableOpacity`
  font-size: 10px;
  letter-spacing: 2px;
  width: 160px;
  height: 35px;
  background: #3366cc;
  color: white;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
`;

export const TodaysWorkoutActivityHeaderPhone = styled(WorkoutContainerHeaderThree)`
  color:white;
`

export const TodaysWorkoutActivityHeaderTablet = styled(WorkoutContainerHeaderThree)`

`

export const TodaysWorkoutTextTablet = styled(WorkoutContainerText)`
  font-size: 16px;
  width:250px;
`;

export const TodaysWorkoutTextPhone = styled(WorkoutContainerText)`
  font-size: 16px;
  width:100%;
  color:white;
`;

export const TodoListTablet = styled.View`
  margin-top: 10px;
  width: 100%;
  max-width: 200px;
  margin-bottom: -5px;
`;

export const TodoListPhone = styled.View`
  margin-top: 10px;
  width: 100%;
`;

export const ActivityContainer = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;

export const ActivityStatus = styled.View`
  width: 22.5px;
  height: 22.5px;
  margin-top: 0px;
  border-radius: 20px;
  background: ${(props) => (props.isCompleted ? '#88cdb2' : 'transparent')};
  margin-right: 7.5px;
  border: 2px solid #88cdb2;
  display:flex;
  justify-content:center;
  align-items:center;
`;

export const ActivityName = styled(WorkoutContainerText)`
  color: ${props => props.devicePhone == 1 ? '#FFF' : '#282F63'};
  font-size: 16px;
`;

export const FreeChoiceButton = styled(WorkoutCommonButton)`
  background:transparent;
  border:2px solid #b8daff;
`

const ModalViewParent = styled.View`
  flex:1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.5);
`;

const ModalView = styled.View`
  width:300px;
  height:auto;
  border-radius:15px;
  text-align:center;
  padding:25px;
  background:white;
`

export const ButtonCont = styled.TouchableOpacity`
    height:35px;
    width:200px;
    background:#3366cc;
    display:flex;
    justify-content:center;
    align-items:center;
    border-radius:50px;
    margin-top:15px;
`

export const ButtonText = styled.Text`
    font-size:16px;
    color:white
`;

export default TodaysWorkout;
